jQuery(function ($) {
  // function displaySpellCheckResults(data) {
  //   var $didYouMean = $(".search-container__did-you-mean");
  //   var $didYouMeanTerm = $(".search-container__did-you-mean-term");
  //   $didYouMean.removeClass("hidden").attr("data-term", data);
  //   $didYouMeanTerm.html(data);
  // }
  // function clearSpellCheckResults() {
  //   var $didYouMean = $(".search-container__did-you-mean");
  //   var $didYouMeanTerm = $(".search-container__did-you-mean-term");
  //   $didYouMean.addClass("hidden").attr("data-term", "");
  //   $didYouMeanTerm.html("");
  // }
  // function appendSpellCheckResults(data) {
  //   if (data && data.length) {
  //     displaySpellCheckResults(data);
  //   } else {
  //     clearSpellCheckResults();
  //   }
  // }
});
